// Changement des balises selects des variations en boutons radios
import $ from 'jquery';

const customVariations = document.getElementsByClassName('custom-wc-variations');
if (customVariations.length > 0) {
    Array.from(customVariations).forEach(function (variation) {
        const radios = variation.querySelectorAll('input[type=radio]');
        radios.forEach(function (radio) {
            radio.addEventListener('change', function () {
                const variationName = radio.getAttribute('data-variation-name');
                const selectBox = document.querySelector('select[name=' + variationName + ']');
                selectBox.value = radio.getAttribute('data-value');
                $(selectBox).trigger('change');
            });
        });
    });
}